module.exports = __webpack_public_path__ + "img/cases-brand-maxam-14.d11cfa81.jpg";